const fromdata = [{
		inputdata: '',
		title: '产品线',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'select',
		width: '490px',
		options: [],
	}, {
		inputdata: '',
		title: '经销商',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'selectautocompletes',
		width: '490px',
		options: [],
		hidden: false,
	},
	{
		inputdata: '',
		title: '盘点名称',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '480px',
	},
	{
		inputdata: '',
		title: '盘点备注',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '480px'
	}
]
export default fromdata;